import { render, staticRenderFns } from "./CloseDisputeDialog.vue?vue&type=template&id=b21dfd8e&"
import script from "./CloseDisputeDialog.vue?vue&type=script&lang=js&"
export * from "./CloseDisputeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports